import { CHANGE_INPUT_SEARCH, SUBMIT_FORM } from './actionTypes.js';

export function onSubmitForm(input, value) {
    return { type: CHANGE_INPUT_SEARCH,input: input }
}